<template>
  <client-only>
    <cms-pop-up-manager />
  </client-only>
</template>
